import axios, { AxiosResponse } from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery } from "react-query";
import { AllOrderResponse } from "types/order-all";

export interface UseAllOrderParams {
    page?: string;
    per_page?: string;
    status?: string;
    fullname?: string;
    date?: string;
    type?: string;
    is_mitra?: string | boolean;
}

interface GetAllOrder extends AxiosResponse {
    data: AllOrderResponse
}

const useAllOrder = (params: UseAllOrderParams) => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();

    const queryParams = new URLSearchParams(params as unknown as Record<string, string>).toString();

    return useQuery<unknown, unknown, GetAllOrder>({
        queryKey: ['get-all-orders', queryParams],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/orders?${queryParams}`, { headers })
            } catch (err) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
            }
        },
    })
}

export default useAllOrder;